/**
 * Footer Component
 * Displays copyright information at the bottom of pages
 */

export function Footer({ className = "" }) {
  return (
    <footer className={`w-full py-4 mt-8 border-t bg-background ${className}`}>
      <div className="container mx-auto px-4 md:px-6">
        <p className="text-center text-sm text-muted-foreground">
          Copyright © 2026 Digilytes LLC. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
